import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { dashboardCardData } from "./FrontDeskData";

function Dashboard(props) {
  const cards = dashboardCardData(props?.dashBorardUpperData);
  return (
    <>
      <Grid container gap={1.5} rowGap={1.5} justifyContent="space-around">
        {cards.map((card, index) => (
          <Grid
            container
            item
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            key={index}
            xs={12}
            md={3.89}
            lg={2.8}
            xl={2.89}
            className="dashboardCards p20"
          >
            <Grid item xs={3}>
              <img src={card?.img} alt="img" />
            </Grid>
            <Grid item xs={9}>
              <Typography className="colorBlack pb10">{card.title}</Typography>
              <Typography className="colorBlack fw600">
                {card.subTitle}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default Dashboard;
